import React from 'react';
import { useTranslation } from 'react-i18next';

const SecurityAndExperience = () => {
    const { t } = useTranslation();
    
    return (
        <div className="security-experience">
            <div className="security-experience-card">
                <div className="security-experience-card-content">
                    {/* İçerik buraya eklenecek */}
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="d-flex flex-column h-100 justify-content-between position-relative">
                                <h4>{t('securityExperience.securityTitle')}</h4>
                                <div className='security-experience-card-content-image'>
                                    <img src="/assets/images/new-img/guvenlik-onceligimiz.png" alt="" width="225px" />
                                </div>
                                <div className='security-experience-card-content-item'>
                                    <h6>{t('securityExperience.multiLayerTitle')}</h6>
                                    <p className="mb-0">
                                        {t('securityExperience.multiLayerText')}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className='security-experience-card-content-item mt-lg-4'>
                                <h6>{t('securityExperience.coldWalletTitle')}</h6>
                                <p className="mb-0">
                                    {t('securityExperience.coldWalletText')}
                                </p>
                            </div>
                            <div className='security-experience-card-content-item mt-lg-4'>
                                <h6>{t('securityExperience.transparencyTitle')}</h6>
                                <p className="mb-0">
                                    {t('securityExperience.transparencyText')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-lg-5">
                <div className="security-experience-card-content">
                    <div>
                        <h4>{t('securityExperience.experienceTitle')}</h4>
                        <div>
                            <div className='d-flex align-items-center gap-2 mt-lg-4 mt-4'>
                                <img src="https://www.coinex.com/assets/img/home/information/newbie.webp?t=1004" alt="" width="40px" />
                                <p className='security-experience-card-content-item-text mb-0'>
                                    {t('securityExperience.simpleInterface')}
                                </p>
                            </div>
                            <div className='d-flex align-items-center gap-2 mt-lg-3 mt-3'>
                                <img src="https://www.coinex.com/assets/img/home/information/newbie.webp?t=1004" alt="" width="40px" />
                                <p className='security-experience-card-content-item-text mb-0'>
                                    {t('securityExperience.support247')}
                                </p>
                            </div>
                            <div className='d-flex align-items-center gap-2 mt-lg-3 mt-3'>
                                <img src="https://www.coinex.com/assets/img/home/information/newbie.webp?t=1004" alt="" width="40px" />
                                <p className='security-experience-card-content-item-text mb-0'>
                                    {t('securityExperience.easyTrading')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SecurityAndExperience;
